import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';

const Section: React.FC<PropsWithChildren<{
    title: string,
    color?: string,
    noMargin?: boolean,
}>> = ({ children, title, color, noMargin = false }) => {

    return (
        <Box sx={{ mt: noMargin ? 0 : 2 }}>
            <Box
                component='h2'
                sx={{
                    m: 0,
                    mb: 1,
                    borderBottom: `1px solid ${color ? color : 'black'}`,
                }}
            >
                {title}
            </Box>

            {children}

        </Box>
    )
}

export { Section };